import { z } from 'zod';

const returnsPreferencesReturnMethodsEnum = z.enum([
  'mail',
  'printerless_mail',
  'boxless',
  'store',
  'home_pickup',
  'concierge',
]);

const carriersSchema = z.coerce.string();
const locationSchema = z.object({
  address1: z.coerce.string(),
  address2: z.coerce.string(),
  city: z.coerce.string(),
  region: z.coerce.string(),
  regionCode: z.coerce.string(),
  postalCode: z.coerce.string(),
  country: z.coerce.string(),
  countryCode: z.coerce.string(),
});

export const returnsPreferencesSchema = z.object({
  carriers: z.array(carriersSchema),
  locations: z.array(locationSchema),
  return_methods: z.array(returnsPreferencesReturnMethodsEnum),
});

export type ReturnsPreferences = z.infer<typeof returnsPreferencesSchema>;
export type ReturnsPreferencesReturnMethodsEnum = z.infer<
  typeof returnsPreferencesReturnMethodsEnum
>;
